import { css } from '@emotion/css';
import React from 'react';
import { FadeInImage } from 'src/components/shared/FadeInImage';
import { Star, TwinkleStars } from 'src/components/shared/TwinkleStars';

interface BottomImageProps {
  pointFactor: number;
}

const green1 = '#b8f0a4';
const green2 = '#a9f78d';
const duration = 340;
const size = 28;
const doubleStars = [
  { position: { x: '30%', y: '65%' }, color: green1, size, rest: 500, duration },
  { position: { x: '65%', y: '60%' }, color: green2, size, rest: 750, duration },
  { position: { x: '51%', y: '85%' }, color: green1, size, rest: 1000, duration },
  { position: { x: '30%', y: '65%' }, color: green2, size, rest: 1500, duration },
  { position: { x: '65%', y: '60%' }, color: green1, size, rest: 1750, duration },
  { position: { x: '51%', y: '85%' }, color: green2, size, rest: 2000, duration }
];
const tripleStars = [
  { position: { x: '15%', y: '38%' }, color: green1, size, rest: 500, duration },
  { position: { x: '40%', y: '80%' }, color: green2, size, rest: 750, duration },
  { position: { x: '78%', y: '44%' }, color: green1, size, rest: 1000, duration },
  { position: { x: '15%', y: '38%' }, color: green2, size, rest: 1750, duration },
  { position: { x: '40%', y: '80%' }, color: green1, size, rest: 2000, duration },
  { position: { x: '78%', y: '44%' }, color: green2, size, rest: 2250, duration }
];

export const BottomImage: React.FC<BottomImageProps> = ({ pointFactor }) => (
  <div
    className={css`
      width: 100%;
      max-width: 480px;
      margin: 0 auto;
    `}
  >
    <BottomImageContent pointFactor={pointFactor} />
  </div>
);

const BottomImageContent: React.FC<BottomImageProps> = ({ pointFactor }) => {
  switch (pointFactor) {
    case 2:
    case 3:
      return (
        <TwinkleStars stars={getStarPattern(pointFactor)}>
          <FadeInImage
            srcSet={getImageSrc(pointFactor)}
            width={480}
            height={120}
            style={{ objectFit: 'cover' }}
          />
        </TwinkleStars>
      );
    default:
      return (
        <FadeInImage
          srcSet={getImageSrc(pointFactor)}
          width={480}
          height={120}
          style={{ objectFit: 'cover' }}
        />
      );
  }
};

function getImageSrc(pointFactor: number) {
  switch (pointFactor) {
    case 2:
      return `/images/fortune/img_nookpoint_bg_double-2x.png 2x, /images/fortune/img_nookpoint_bg_double.png 1x`;
    case 3:
      return `/images/fortune/img_nookpoint_bg_triple-2x.png 2x, /images/fortune/img_nookpoint_bg_triple.png 1x`;
    default:
      return `/images/fortune/img_hill_480-2x.png 2x, /images/fortune/img_hill_480.png 1x`;
  }
}

function getStarPattern(pointFactor: number): Star[] {
  switch (pointFactor) {
    case 2:
      return doubleStars;
    case 3:
      return tripleStars;
    default:
      return [];
  }
}
